import { autorun, observable, action } from 'mobx';
import axios from 'axios';
import { ReactGA } from 'sd-ui-components';
import { logAjaxTiming } from '../apis/GoogleAnalyticsApi';

const userNameDimension = 'dimension3';
const companyDimension = 'dimension1';

export default class GoogleAnalyticsStore {
  @observable isInitialized = false;

  initializationHandler = () => {};

  constructor(rootStore) {
    this.rootStore = rootStore;
  }

  async init() {
    this.watchForConfigChanges();
  }

  watchForConfigChanges() {
    this.initializationHandler = autorun(() => {
      const googleAnalyticsTrackingId = this.rootStore.configStore.config[
        this.rootStore.configStore.configurationKeys.googleAnalyticsTrackingId
      ];

      if (!googleAnalyticsTrackingId) {
        return;
      }

      this.initialize(googleAnalyticsTrackingId);
    });
  }

  @action
  initialize(googleAnalyticsTrackingId) {
    ReactGA.initialize(googleAnalyticsTrackingId);

    this.isInitialized = true;

    /* Setup the watchers */
    this.configureInterceptors();
    this.watchForUserChanges();

    /* Dereference the autowatcher . */
    this.initializationHandler();
  }

  /**
   * Internal functions. Adds Axios interceptors for request and response to allow for tracking the round-trip time for AJAX requests.
   * These rountrip times will be logged to Google Analytics as 'timing' events.
   */
  configureInterceptors() {
    axios.interceptors.request.use(config =>
      this.ajaxTimingRequestInterceptor(config)
    );
    axios.interceptors.response.use(response =>
      this.ajaxTimingResponseInterceptor(response)
    );
  }

  ajaxTimingRequestInterceptor(config) {
    config.__requestStartTime = Date.now();

    return config;
  }

  ajaxTimingResponseInterceptor(response) {
    const requestDuration = Date.now() - response.config.__requestStartTime;

    /**
     * The request path here is everything up to the query parameters.
     * GA will refuse to send any data which looks like emails, so this
     * removes any possibility of data like that being sent.
     */
    const requestPath = response.config.url.substring(
      0,
      response.config.url.indexOf('?') > -1
        ? response.config.url.indexOf('?')
        : response.config.length
    );

    if (this.isInitialized) {
      logAjaxTiming(requestPath, requestDuration);
    }

    return response;
  }

  /**
   * Wathches for changes to the AuthStore userInfo object and updates the Google Analytics variables.
   *
   * This autorun needs to stay alive for the entire runtime of the app, so it is not dereferenced.
   */
  watchForUserChanges() {
    autorun(() => {
      if (!this.isInitialized) {
        return;
      }

      ReactGA.set({
        [userNameDimension]: this.rootStore.authStore.userInfo.userName,
        [companyDimension]: this.rootStore.authStore.userInfo.companyHash
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/stores/GoogleAnalyticsStore.js